export default __webpack_public_path__ + "static/media/ForensicLedgerRight.85a16c13.png";